<mat-nav-list class="mat-nav">
  @for (menuItem of menus; track menuItem) {
    <div class="list-of-item" [class.active]="getLastPathSegment() === menuItem.code" (click)="navigateTo(menuItem.link)">
      @if (!menuItem.children || menuItem.children.length === 0) {
        <span>
          <mat-list-item class="custom-list">
            @if (menuItem.hasIcon) {
              <mat-icon class="custom-color">{{ menuItem.icon }}</mat-icon>
            }
            <!-- <img [src]="menuItem.icon" alt=""> -->
            <div class="custom-color">{{ menuItem.name }}</div>
          </mat-list-item>
        </span>
      }
    </div>
  }
</mat-nav-list>